// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 12", width: "16", height: "12" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", { fillRule: "nonzero" },
                React.createElement("path", { d: "M887,1952 C882.582,1952 879,1957 879,1958 C879,1959 882.582,1964 887,1964 C891.418,1964 895,1959 895,1958 C895,1957 891.418,1952 887,1952 Z M887,1960.5 C885.619375,1960.5 884.5,1959.38063 884.5,1958 C884.5,1956.61937 885.619375,1955.5 887,1955.5 C888.380625,1955.5 889.5,1956.61937 889.5,1958 C889.5,1959.38063 888.380625,1960.5 887,1960.5 Z", transform: "translate(-879 -1952)" })))));
};
Icon.displayName = 'Eye16x12';
export default Icon;
//# sourceMappingURL=Eye16x12.js.map